<ng-container *transloco="let t">
  <button
    vinnova-button-text
    type="button"
    class="mt-1"
    (click)="onNavigateToSearch()"
  >
    <lib-icon name="chevron-left"></lib-icon>{{ t('worksite_search_back') }}
  </button>

  <div class="row" [class.faded]="isLoading">
    <div class="col-12">
      <h2 class="heading-size-4" id="modalTitle">{{ t('worksite_add') }}</h2>
      <div class="alert alert-warning m-0">
        <div class="d-flex align-items-center">
          <lib-icon name="alert-triangle" size="x-small"></lib-icon>
          <div class="ms-2">
            <p class="m-0">
              {{ t('worksite_add_info') }}
            </p>
            <p class="m-0">
              {{ t('worksite_add_address_info') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <form
      [formGroup]="form"
      (submit)="selectedCompany ? createWorksite() : createCompanyAndWorksite()"
    >
      <div class="row mt-5">
        <div class="col-md-6 col-sm-12">
          <div class="border p-3 position-relative h-100">
            <div class="col-header">
              <h3 class="m-0 heading-size-4">
                {{ t('worksite_organisation') }}
              </h3>
            </div>
            @if (companyForm) {
              <lib-create-company
                [selectedCompany]="selectedCompany"
                [form]="companyForm"
                [countries]="countries"
                [isProjectPart]="isProjectPart$ | async"
                (duplicated)="isDuplicated = $event"
                (selectCompany)="onSelectCompany($event)"
              >
              </lib-create-company>
            } @else {
              <div class="mt-3">
                <h4 class="heading-size-5">{{ selectedCompany.name }}</h4>
              </div>
            }
          </div>
        </div>

        <div class="col-md-6 col-sm-12">
          <div class="border p-3 position-relative h-100">
            <div class="col-header">
              <h3 class="m-0 heading-size-4">{{ t('worksite_worksite') }}</h3>
            </div>

            @if (worksiteForm && !showWorksiteSuggestions) {
              <lib-create-worksite
                [selectedCompany]="selectedCompany"
                [form]="worksiteForm"
                [countries]="countries"
                [disabled]="companyForm && companyForm.invalid"
                (duplicated)="isWorksiteDuplicated = $event"
                (selectWorksite)="onSelectWorksite($event)"
              >
              </lib-create-worksite>
            }
            @if (
              showWorksiteSuggestions && selectedCompany && !selectedWorksite
            ) {
              <div>
                <div class="row border-bottom py-2">
                  <div class="col-4">
                    <strong>{{ t('worksite_name') }}</strong>
                  </div>
                  <div class="col-6 p-0">
                    <strong>{{ t('worksite_address') }}</strong>
                  </div>
                </div>
                <lib-search-result
                  [minified]="true"
                  (createWorksite)="onCreateWorksite()"
                  (selectWorksite)="onSelectWorksite($event)"
                >
                </lib-search-result>
              </div>
            }

            @if (selectedWorksite) {
              <div class="mt-3">
                <h4 class="heading-size-5">{{ selectedWorksite.name }}</h4>
              </div>
            }
          </div>
        </div>
      </div>

      @if (companyForm || worksiteForm) {
        <div class="mt-3">
          <div class="row">
            <div class="col-md-auto col-sm-12 mt-2">
              @if (!showWorksiteSuggestions) {
                <button
                  vinnova-button-primary
                  class="me-3"
                  type="submit"
                  [disabled]="
                    form.invalid ||
                    form.untouched ||
                    isLoading ||
                    isCompanyDuplicated ||
                    isWorksiteDuplicated
                  "
                >
                  {{ t('worksite_btn_save') }}
                </button>
              }
              @if (!showWorksiteSuggestions) {
                <button
                  vinnova-button-secondary
                  class="me-3"
                  type="button"
                  (click)="resetForm()"
                  [disabled]="isLoading || showWorksiteSuggestions"
                >
                  {{ t('worksite_btn_clear') }}
                </button>
              }
            </div>
            <div class="col-md-auto col-sm-12 mt-2">
              @if (companyForm) {
                <button
                  vinnova-button-primary
                  type="button"
                  [libTooltip]="t('worksite_copy_info')"
                  triggers="hover-persist"
                  placement="top"
                  [disabled]="(disableButton$ | async) || copiedForm"
                  (click)="copyValues(); copiedForm = true"
                >
                  {{ t('worksite_btn_copy') }}
                </button>
              }
            </div>
          </div>
        </div>
      }

      @if (isLoading) {
        <div class="overlay-loader">
          <div class="loader"></div>
        </div>
      }
    </form>
  </div>
</ng-container>
